<template>
  <div class="book">
    <img src="../../assets/NewYear/Page.png" class="page" />
    <div class="book-container">
      <p>Le comte a une nouvelle fois besoin d'aide ...</p>
      <ul>
        <li>Il ne faut pas perdre une minute, annonça le plus grand !</li>
        <li>C'est vrai que Mamie à l'air plus inquiète que d'habitude, répondit le plus joufflu...</li>
        <li>
          La dernière fois, il l'avait seulement perdu. Là, il se l'est fait voler, renchérit le
          plus curieux !
        </li>
        <li>Brou brou brou brou, conclut leur drôle d'animal.</li>
      </ul>
      <p>
        Les trois garçons étaient à la fois inquiets et excités. S'ils avaient pris l'habitude de
        devoir aider le comte, le même problème se posait chaque année : ce dernier possèdait un
        chateau dans plusieurs pays d'Europe et il fallait commencer par le retrouver. Il n'était
        pas possible de le joindre, mais il écrivait régulièrement pour donner des nouvelles. Il ne
        retournait jamais deux fois dans le même château lors d'une année, les garçons avaient donc
        procédé par élimination :
      </p>
      <ul>
        <li>Voila toutes les lettres de mamie annonça le plus joufflu...</li>
        <li>
          On sait donc que le comte est déjà passé par l'Allemagne, la Belgique, la Bulgarie,
          l'Estonie,l'Irlande, la Lituanie et la Roumanie fit remarquer le plus grand.
        </li>
        <li>
          Si je réfléchis bien, ça ne nous laisse donc que six possibilités déclara le plus curieux
          !
        </li>
        <li>Brouuu brouuu brouuu, laissa échapper leur drôle d'animal.</li>
      </ul>
      <p>Et c'est ainsi qu'ils se mirent en route.</p>
      <p>
        Nos trois aventuriers commencèrent par le château de Durham. Ils l'avaient déjà visité, et
        comme à chaque fois, ils étaient ravis de prendre le bateau pour s'y rendre. La traversée
        était longue, mais les trois compères s'occupaient avec les jeux des pages du journal que
        Mamie leur avait donné. Le plus joufflu ne savait pas encore bien lire, mais les deux aînés
        lisaient pour le petit groupe à tour de rôle :
      </p>
      <ul>
        <li>
          Tiens, c'est rigolo, cette semaine, on nous propose justement de classer des châteaux dans
          le « jeu trop classe », s'écria le plus curieux !
        </li>
        <li>Les deux autres rirent aux éclats !</li>
        <li>Brou brouuu brou, chouina l'animal qui n'avait apparemment pas compris la blague.</li>
      </ul>
      <p>
        Mais les rires s'estompèrent une fois arrivés sur place : le comte n'était pas présent au
        château, et il fallait donc continuer les recherches. Une fois le bateau repris en sens
        inverse, c'était maintenant parti pour voyager en train pour le reste de l'aventure. Les
        trois garçons se regardèrent...
      </p>
      <ul>
        <li>Direction le château de Malbork, s'exclamèrent-ils à l'unisson !</li>
        <li>Brou brouuu brou brou, sembla participer l'animal.</li>
      </ul>
      <p>
        Le voyage continuait et les jeux s'enchaînaient. Le plus joufflu était triste, car sa
        rubrique favorite, la recette de Maïté, avait laissé place à une drôle d'énigme dans
        l'édition qu'ils avaient emporté avec eux. Le plus grand et le plus curieux, eux, étaient
        ravis. Ils ne déchantèrent même pas lorsqu'ils apprirent que leur second choix n'était
        toujours pas le bon, ils avaient finalement pris l'habitude de ces péripéties. Ils se dirent
        alors qu'ils devraient peut-être laisser le choix à leur drôle de compagnon pour la
        prochaine destination :
      </p>
      <ul>
        <li>Brouuu brouuu brouuu, fit l'animal !</li>
      </ul>
      <p>
        Mais comme ils ne comprirent pas ce qu'il tentait de leur dire, ils filèrent vers le château
        d'Eggenberg, qui était le château le plus proche de là où ils se trouvaient. Ce choix leur
        parut malin, et ils rirent d'avoir pu penser que la créature aurait pu les aider.
      </p>
      <p>
        Le trajet était court, alors le journal resta rangé dans leur valise. Le plus joufflu en fut
        déçu.
      </p>

      <p>
        Mais pas non plus de traces du comte au château d'Eggenberg. A chaque nouveau voyage, les
        chances que le prochain château soit le bon augmentaient. Les garçons continuèrent donc
        ainsi leur traversée de l'Europe en filant vers l'Est, en direction du château de Budapest.
      </p>
      <ul>
        <li>Je ne comprends rien aux mots croisés, s'écria dépité le plus curieux !</li>
      </ul>
      <p>
        Il semblait peiné. Le plus grand chercha donc à l'aider, même s'il n'aimait pas beaucoup ce
        type de loisir.
      </p>
      <ul>
        <li>Mais moi non plus, rétorqua-t-il surpris !</li>
        <li>Brouuu brouuu brou, entonna l'animal, comme pour les réconforter.</li>
      </ul>
      <p>Malgré leur déconvenue avec les mots-croisés, le voyage passa rapidement. Les enfants arrivèrent sans s'en rendre compte jusqu'à l’impressionnant palais surplombant le Danube.</p>
      <ul>
        <li>Cette fois-ci, c'est la bonne, annonça enjoué le plus joufflu !</li>
        <li>Brou, ponctua l'animal, marquant ainsi son profond accord.</li>
      </ul>
      <p>
        Mais évidemment, ils se trompaient tous les deux : encore une fois, le comte n'était pas là.
        L'inquiétude grandissait... se pouvait-il qu'ils ne tombent sur le comte qu'en tout dernier
        lieu, comme cela était déjà arrivé deux années auparavant ?
      </p>
      <p>
        Aucun des trois garçons ne le souhaitait. Leur drôle d'animal ne le souhaitait sûrement pas
        non plus. Cependant, ils pensaient tous les trois que leur avant-dernier choix serait
        inévitablement le mauvais. Ils avaient sorti leur écharpe, remonté la fermeture éclair de
        leur manteau, et étaient partis sans trop y croire vers le château de Mir...
      </p>
      <p>...qui s'avéra ne pas être la dernière étape de leur périple !</p>

      <p>
        Ils prirent donc leur mal en patience, sortirent une dernière fois le journal de Mamie et
        savaient donc maintenant que ce trajet serait le dernier. Il fut rapide, leur attention
        toute portée au drôle de quizz où le plus joufflu s'avéra également le plus cultivé.
      </p>
      <p>
        Une fois arrivés devant la porte du dernier château, leurs doutes furent finalement
        immédiatement levés :
      </p>
      <ul>
        <li>C'est ici, c'est certain, se réjouit le plus grand ! Le château est entièrement décoré.</li>
        <li>Et cela sent bon la cuisine de fêtes, ajouta le plus joufflu.</li>
        <li>Vite, dépêchons nous d'entrer, nous avons une mission importante, rappela le plus curieux.</li>
        <li>Brou brou brou, confirma leur drôle d'animal !</li>
      </ul>
      <div style="text-align: center; width: 100%:">
        <img src="../../assets/NewYear/Castle.png" alt />
      </div>
      <div class="hints hints-picture">
        <div v-for="(hint, index) in castleList" :key="index">
          <button
            :class="getClass(castleList,hint, index)"
            @click="display(hint.id)"
            :disabled="getClass(castleList,hint, index) === 'inactive' "
          >💡 #{{index + 1}}</button>
        </div>
      </div>
      <div v-for="(hint, index) in castleList" :key="index">
        <hint
          v-if="hint.display"
          :content="hint.content"
          :index="index"
          :read="hint.read"
          @close="closeHints()"
          @continue="increment(hint.id)"
        />
      </div>
    </div>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(reduceList,hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(reduceList,hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../shared/Hint";

export default {
  name: "Book",
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "book"),
      castleList: this.hintList.filter(h => h.vue === "picture")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(list, hint, index) {
      if (hint.read) return "read";
      if (index === 0) return "active";
      if (list[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
p {
  font-family: "IBM Plex Mono", monospace;
  color: rgb(35, 35, 35);
  font-size: 16px;
}
.book {
  top: 0;
  position: relative;
  margin: 0;
  height: 92%;
}
.book-container {
  width: 78%;
  height: 80%;
  margin: 6%;
  padding: 3%;
  background: #f3f0ee;
  overflow: scroll;
  border: 15px solid #318cc7;
  border-radius: 10px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 16px;
}
.book-container img {
  max-width: 100%;
  border-radius: 50px;
}
li {
  list-style-type: "-";
}
.page {
  position: absolute;
  height: calc(7.5% + 15px);
  top: 15px;
  right: 17%;
}
.hints-picture {
  top: 2%;
}
.hints {
  position: relative;
  bottom: 2%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
